// Links into Salesforce, when the payload says where Salesforce is.
//
// `salesforce_instance_url` comes from the payload. If it's ever missing, every function here
// returns null and the board shows names as plain text.

export function recordUrl(instanceUrl: string | null | undefined, objectName: string, recordId: string): string | null {
  if (!instanceUrl || !recordId) return null;
  return `${instanceUrl.replace(/\/+$/, '')}/lightning/r/${objectName}/${recordId}/view`;
}

export function opportunityUrl(instanceUrl: string | null | undefined, oppId: string): string | null {
  return recordUrl(instanceUrl, 'Opportunity', oppId);
}

export function accountUrl(instanceUrl: string | null | undefined, accountId: string): string | null {
  return recordUrl(instanceUrl, 'Account', accountId);
}
